import {
    GET_EVENT_API_KEY_SUCCESS,
    GET_EVENT_API_KEY_FAILURE
} from "./actions";

const initialState = {
    getEventApiKeyResult: {
        success: true
    },
    apiKeyRevision: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_EVENT_API_KEY_SUCCESS:
            return { ...state, getEventApiKeyResult: { success: true }, apiKeyRevision: action.payload.apiKeyRevision };
        case GET_EVENT_API_KEY_FAILURE:
            return {
                ...state, getEventApiKeyResult: { success: false, ...action.payload.error }, apiKeyRevision: null
            };
        default:
            return state;
    }
};
